import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthenticationActions, AuthenticationApiActions } from './authentication.actions';
import { User } from './model/user.model';
import { Observable } from 'rxjs';
import { ErrorCode } from '../../models/error-code.model';
import { selectAuthenticated, selectSignInError, selectUser } from './authentication.selector';
import { UserCredentials } from './model/user-credentials.model';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationFacade {
    signInError$: Observable<ErrorCode | null> = this.store.select(selectSignInError);
    user$: Observable<User | null> = this.store.select(selectUser);
    authenticated$: Observable<boolean> = this.store.select(selectAuthenticated);

    constructor(private store: Store) {}

    signIn(data: UserCredentials): void {
        this.store.dispatch(AuthenticationApiActions.signIn({ credentials: data }));
    }

    signOut(): void {
        this.store.dispatch(AuthenticationApiActions.signOut());
    }

    resetPassword(email: string): void {
        this.store.dispatch(AuthenticationApiActions.resetPassword({ email: email }));
    }

    authenticationFailed(): void {
        this.store.dispatch(AuthenticationActions.authenticationFailed());
    }

    setUser(user: User): void {
        this.store.dispatch(AuthenticationActions.setUser({ user }));
    }
}
